import axios from 'axios';
import { whichPath } from './utils';

const axiosInstance = axios.create();

axiosInstance.interceptors.request.use((config) => {
    // Base path
    const basePath = whichPath(true);

    // Check config
    if (config.url.startsWith('/')) {
        config.url = basePath + config.url.replace('/api', '');
    }

    // Return config
    return config;
}, (error) => {
    // Return error
    return Promise.reject(error);
});

// Export axios config
export default axiosInstance;

